import { Component, OnInit, TemplateRef } from '@angular/core';
import { LocalLocationContainer } from '../shared/local-location-container.model';
import { catchError, tap } from 'rxjs/operators';
import { ModalService } from '../../shared/services/modal.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../shared/services/loader.service';
import { LocalLocationService } from '../shared/local-location.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss']
})
export class LocationsComponent implements OnInit {

  selectedLocation: LocalLocationContainer;

  synchronizedGlid: string;
  syncForm: { glid?: string } = {};

  canManageLocations = false;

  constructor(
    private modalService: ModalService,
    private authService: AuthenticationService,
    private translate: TranslateService,
    private loader: LoaderService,
    private locationService: LocalLocationService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandlerService,
  ) {
    this.canManageLocations = this.authService.canManageLocations();
  }

  ngOnInit() {
  }

  openSyncLocation(content: TemplateRef<any>) {
    this.syncForm = {};

    this.modalService.open({
      title: this.translate.instant('local-loads.locations.detail.modals.sync.title-new'),
      content,
      validateButton: {
        text: this.translate.instant('local-loads.locations.detail.modals.sync.buttons.save'),
        icon: 'fa fa-sync-alt',
        disabled: () => !this.syncForm.glid
      },
      beforeResolve: () => this.loader.startLoadAndCloseWhenComplete(
        this.locationService.syncWithSap(this.syncForm.glid)
          .pipe(
            tap(() => this.toastr.success(this.translate.instant('local-loads.locations.detail.successes.sync-with-sap', { glid: this.syncForm.glid }))),
            catchError(e => this.errorHandler.rethrowHttpError(e, 'local-loads.locations.detail.errors.sync-with-sap', false)),
          )
      ),
    }).subscribe(() => {
      this.synchronizedGlid = this.syncForm.glid;
    });
  }

  closeDetail() {
    this.selectedLocation = null;
  }
}
